import createRecordNotification from 'components/Notification/createRecordNotification';
import NOTIFICATION_STRINGS from './Constants/notificationString';

export const CREATE_SUCCESS_KEY = 'plan-create-success';
export const CREATE_CLASSNAME_PREFIX = 'plan-creation';

/**
 * Fires a Plan save-confirmation toast. Deferred until `PlansPage` signals
 * its print listener is ready, since the wizard navigates back to the list
 * — and unmounts — before that toast is meant to appear on it.
 */
const {
  notify: planNotification,
  dismiss: dismissPlanNotification
} = createRecordNotification<
  'CREATE_SUCCESS' | 'EDIT_SUCCESS' | 'CREATE_OR_EDIT_ERROR' | 'DELETE_ERROR',
  'onDuplicate' | 'onPrint'
>({
  notificationKey: CREATE_SUCCESS_KEY,
  classNamePrefix: CREATE_CLASSNAME_PREFIX,
  strings: {
    SAVED: NOTIFICATION_STRINGS.PLAN_SAVED,
    UPDATED: NOTIFICATION_STRINGS.PLAN_UPDATED,
    DELETED: NOTIFICATION_STRINGS.PLAN_DELETED,
    DUPLICATE_BUTTON: NOTIFICATION_STRINGS.DUPLICATE_BUTTON,
    PRINT_PDF_BUTTON: NOTIFICATION_STRINGS.PRINT_PDF_BUTTON,
    ERROR_TITLE: NOTIFICATION_STRINGS.ERROR_TITLE,
    ERROR_MESSAGE: NOTIFICATION_STRINGS.ERROR_MESSAGE,
    DELETE_ERROR_TITLE: NOTIFICATION_STRINGS.DELETE_ERROR_TITLE,
    DELETE_ERROR_MESSAGE: NOTIFICATION_STRINGS.DELETE_ERROR_MESSAGE,
    CONTACT_BUTTON: NOTIFICATION_STRINGS.CONTACT_BUTTON
  }
});

export { dismissPlanNotification };

export { closeNotification } from 'components/Notification/genericNotification';
export default planNotification;
